.strip {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-2);
  flex-wrap: nowrap;
  overflow-x: auto;
  /* Horizontal scrolling matches the timeline semantics of a chord progression
     and keeps the selected-slot context glued to the inserted dashed-border
     chip even on narrow viewports (~360px). */
}

.slotGroup {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.insertedChip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: calc(4.5rem * 0.75);
  min-height: 5rem;
  padding: var(--tuna-spacing-2);
  border-left: 1px dashed var(--tuna-border-default);
  border-right: 1px dashed var(--tuna-border-default);
  border-top: 0;
  border-bottom: 0;
  background: transparent;
  cursor: pointer;
}

.insertedTag {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

.insertedName {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 500;
}
